import { Component, OnInit } from '@angular/core';
import {AnalyticsService} from '../components/analytics-service/analytics.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  constructor(private analyticsService: AnalyticsService) {
    this.analyticsService.emitEvent(
      'Page visit',
      'Home'
    );
  }

  ngOnInit() {
  }

}
